export interface UserRef {
    _id: string
    name: string
}

export interface LockInfo {
    lockedBy: UserRef
    lockedAt: string // Date string
}

export interface ArchiveInfo {
    archivedBy: UserRef
    archivedAt: string // Date string
    archivedNote?: string
}

export interface SnapshotData {
    sourceId: string
    sourceStrategyId: string
}

export interface Tpp {
    _id: string
    title: string
    sectionIds: string[]
    columnIds: string[]
    assetAmbition: string
    organizationId?: string
    roadmapId?: string
    versionNumber: number
    execMode: boolean
    isSnapshot: boolean
    snapshotData?: SnapshotData
    createdAt: string
    updatedAt: string
}

export interface TppColumn {
    _id: string
    tppId: string
    organizationId: string
    title: string
    isPinned: boolean
    isSave: boolean
    keyMarkets: any[] // Array in schema
    archived?: ArchiveInfo
    locked?: LockInfo
    createdBy?: string // User ID
    isSnapshot: boolean
    snapshotData?: SnapshotData
    createdAt: string
    updatedAt: string
}

export interface TppSection {
    _id: string
    organizationId: string
    tppId: string
    title: string
    rowIds: string[]
    keyMarkets: any[]
    createdBy?: string
    isSnapshot: boolean
    snapshotData?: SnapshotData
    createdAt: string
    updatedAt: string
}

export interface TppRow {
    _id: string
    title: string
    tppId: string
    sectionId: string
    slotIds: string[]
    context: string[]
    info: string
    createdBy?: string
    isSnapshot: boolean
    snapshotData?: SnapshotData
    createdAt: string
    updatedAt: string
}

export interface TppSlot {
    _id: string
    tppId: string
    rowId: string
    context?: string
}

export interface TppCell {
    _id: string
    tppId: string
    columnId: string
    slotId: string
    organizationId?: string
    content: string
    linkedActivities: string[]
    linkedEvidence: string[]
    linkedValueMessages: string[]
    linkedKeyEvidenceStatements: string[]
    isHighlighted: boolean
    isClone: boolean
    childClones?: string[]
    cloneSource?: string
    createdBy?: string
    locked?: LockInfo
    hasComment: boolean
    isSnapshot: boolean
    snapshotData?: SnapshotData
    createdAt: string
    updatedAt: string
}

// Normalized State for Frontend Usage
export interface TppMatrixState {
    tpp: Tpp | null
    columns: Record<string, TppColumn>
    sections: Record<string, TppSection>
    rows: Record<string, TppRow>
    slots: Record<string, TppSlot>
    cellLookup: Record<string, Record<string, TppCell>> // slotId -> columnId -> Cell
    pinnedColumnIds: string[]
    isLoading: boolean
}

// Dnd Item Types
export const DRAG_TYPES = {
    COLUMN: 'COLUMN',
    SECTION: 'SECTION',
    ROW: 'ROW',
    SLOT: 'SLOT',
    CELL: 'CELL',
    DROP_ZONE: 'DROP_ZONE',
} as const
